import React from "react";
import style from "./FormField.module.scss";
const FormFieldComponent = (props) => {
  const validation = props.validation ? props.validation : { isInvalid: false, message: "" };
  const className = props.className ? props.className : "";
  return (
    <div className={`${style.form_box} ${className} ${validation.isInvalid ? style.invalid : ''}`}>
      {props.children}
      {
        validation.isInvalid && (
          <div className={style.form_validation_wrapper}>
            <span>{validation.message}</span>
          </div>
      )}
    </div>
  );
};
export default FormFieldComponent;
